import { put, call, takeLatest } from "redux-saga/effects";
import { FETCH_PORTAL_CONFIG, setPortalConfig } from "./actions";
import { fetchPortalConfig } from "./request";

export function* fetchPortalConfigSaga(action) {
  try {
    const { portalSlug } = action.payload;
    const response = yield call(fetchPortalConfig, portalSlug);
    const { data = {}, error } = response.data;
    if (!error) {
      yield put(setPortalConfig(data));
    } else if (error) {
      yield put(setPortalConfig({ error }));
    }
  } catch (err) {
    yield put(setPortalConfig({ error: err.response.data }));
  }
}

export default function* portalConfigWatcher() {
  yield takeLatest(FETCH_PORTAL_CONFIG, fetchPortalConfigSaga);
}
